import { useEffect } from "react";

const AnalyticsScripts = () => {
  useEffect(() => {
    const isProduction = window.location.hostname === "getsak.com";
    // const isProduction = ["getsak.com", "www.getsak.com"].includes(window.location.hostname);


    if (!isProduction) return;

    // Inject GTM
    const gtmScript = document.createElement("script");
    gtmScript.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id=GTM-KPR5KDF2'+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-KPR5KDF2');
    `;
    document.head.appendChild(gtmScript);

    // Inject gtag
    const gaScript = document.createElement("script");
    gaScript.src = "https://www.googletagmanager.com/gtag/js?id=G-D68FBHYS9E";
    gaScript.async = true;
    document.head.appendChild(gaScript);

    const gtagInit = document.createElement("script");
    gtagInit.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-D68FBHYS9E');
    `;
    document.head.appendChild(gtagInit);
  }, []);

  return null;
};

export default AnalyticsScripts;
